<nb-layout center class="auth-pages">
	<nb-layout-column>
		<nb-card style="box-shadow: none">
			<nb-card-body>
				<ng-container *ngIf="isTranslationLoaded && !loggedIn">

					<div class="login-container">
						<div class="logo">
							<img style="width: 150px;" src="assets/images/logo.svg" />
							<!-- <span>&nbsp;PATH</span> -->
						</div>
						<nb-alert *ngIf="!!errorMessage" outline="danger" role="alert">
							<p class="alert-title"><b>{{ 'Common.Error' | translation }}</b></p>
							<p>
								{{errorMessage}}
							</p>
						</nb-alert>
						<!--
						<h1 id="title" class="title">
							{{loggedIn ? ('Common.SelectLanguage' | translation) : ('Common.SignIn' | translation) }}
						</h1>
						-->
						<h1 id="title" class="title">
							{{'Common.SignIn' | translation}}
						</h1>
						<form [formGroup]="loginForm" aria-labelledby="title" (ngSubmit)="login()">
							<div class="form-control-group">
								<label class="label" for="emailOrUsername">{{ 'Users.EmailAddress' | translation }}:</label>
								<input nbInput fullWidth formControlName="emailOrUsername" name="emailOrUsername" id="emailOrUsername"
									   placeholder="{{ 'Users.EmailAddress' | translation }}"
									   [status]="loginForm.controls['emailOrUsername'].dirty ? (loginForm.controls['emailOrUsername'].invalid  ? 'danger' : 'success') : ''"
									   [required]="true"
									   [attr.aria-invalid]="loginForm.controls['emailOrUsername'].invalid && loginForm.controls['emailOrUsername'].touched ? true : null">
								<ng-container
										*ngIf="loginForm.controls['emailOrUsername'].invalid && loginForm.controls['emailOrUsername'].touched">
									<p class="error-message" *ngIf="loginForm.controls['emailOrUsername'].errors?.required">
										{{ 'CrmUsers.EmailRequired' | translation }}
									</p>
									<!--									<p class="error-message" *ngIf="loginForm.controls['email'].errors?.pattern">-->
									<!--										Email should be the real one!-->
									<!--									</p>-->
								</ng-container>
							</div>

							<div class="form-control-group">
								<label class="label" for="input-password">{{ 'CrmUsers.Password' | translation }}:</label>
								<div style="position: relative;">
									<input nbInput fullWidth formControlName="password" name="password" [type]="showPassword ? 'text':'password'"
										   id="input-password" placeholder="{{ 'CrmUsers.Password' | translation }}"
										   [status]="loginForm.controls['password'].dirty ? (loginForm.controls['password'].invalid  ? 'danger' : 'success') : ''"
										   [required]="true" [minlength]="6" [maxlength]="255"
										   [attr.aria-invalid]="loginForm.controls['password'].invalid && loginForm.controls['password'].touched ? true : null">
									<i style="cursor: pointer; position: absolute; right: 0.5em; bottom: 0.4em; font-size: 20px;" class="fa {{ showPassword ? 'fa-eye-slash' : 'fa-eye' }}" (click)="toggleShowPassword()"></i>
								</div>
								<ng-container
										*ngIf="loginForm.controls['password'].invalid && loginForm.controls['password'].touched ">
									<p class="error-message" *ngIf="loginForm.controls['password'].errors?.required">
										{{ 'CrmUsers.PasswordRequired' | translation }}
									</p>
								</ng-container>
							</div>

							<!--
							<div class="form-control-group accept-group">
								<nb-checkbox [formControl]="rememberMe">
									{{ 'CrmUsers.RememberMe' | translation }}
								</nb-checkbox>
							</div>
							-->

							<div class="text-center">
								<button fullWidth nbButton status="success" type="submit" [disabled]="!loginForm.valid"
										[nbSpinner]="loading" nbSpinnerStatus="disabled" (click)="login()">
									{{ 'Common.SignIn' | translation }}
								</button>
							</div>

						</form>
						<div style="padding-top:2.5em ;"><a [href]="environment.mobileAppUrl + 'recover'">{{ 'CrmUsers.RecoverPassword' | translation }}</a>
						</div>

						<!--
						<ng-container *ngIf="loggedIn">
							<div class="form-control-group">
								<label class="label" for="input-email">{{ 'Common.Language' | translation }}:</label>
								<nb-select placeholder="{{'Common.SelectLanguage' | translation}}" [ngModel]="crmLanguage_id"
									[ngModelOptions]="{standalone: true}" (ngModelChange)="onChangeLanguage($event)" filled status="primary" size="large" style="display: block;">
									<nb-option *ngFor="let item of crmLanguages" [value]="item.id">
										{{item.language_name}}
									</nb-option>
								</nb-select>
							</div>

							<br />
							<br />

							<div class="text-center">
								<button nbButton status="success" [disabled]="!crmLanguage_id" [nbSpinner]="loading"
									nbSpinnerStatus="disabled" (click)="onLanguageSet()">
									{{ 'Common.Set' | translation }}
								</button>
							</div>
						</ng-container>
						-->
					</div>
				</ng-container>
			</nb-card-body>
		</nb-card>
	</nb-layout-column>
</nb-layout>
